import { AIBGADetails, CLXGADetails, CPXGADetails, CardDetails, MC6GADetails } from "./ga-card-details";
import { CARD_TYPES } from "./ga-enums";

export type CardMapping = {
  [key: string]: CardDetails;
};

export const GACardMapping: CardMapping = {
  [CARD_TYPES.AIB]: AIBGADetails,
  [CARD_TYPES.CLX]: CLXGADetails,
  [CARD_TYPES.CPX]: CPXGADetails,
  [CARD_TYPES.MC6]: MC6GADetails
};
